var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var _ = require('underscore');
var slugify = require('../helpers/slugify');
//var Linkify = require('react-linkify');
var Linkify = require('linkifyjs/react');

// Stores
var LanguageStore = require('../stores/language_store');

// Components
var GenderSelector = require('./gender_selector');

// Module
module.exports = React.createClass({
	
	getInitialState : function(){
		return {
			selected_category_ids : [],
			job_alert_subscribe : false,
			show_more_categories : false
		}	
	},
	
	/*submitForm : function(e){
		e.preventDefault();
		
		var self = this;
		
		var data = {
			name 		: $(e.currentTarget).find("input[name='name']").val(),
			gender 		: '',
			birthdate 	: $(e.currentTarget).find("input[name='birthdate']").val(),
			email 		: $(e.currentTarget).find("input[name='email']").val(),
			phone 		: $(e.currentTarget).find("input[name='phone']").val(),
			description : $(e.currentTarget).find("textarea[name='message']").val(),
			note 		: {
				title : '',
				text : $(e.currentTarget).find("textarea[name='message']").val()
			}
		};
		
		$.ajax({
			url: '/'+this.props.values.env+'/form/'+this.props.values.job_id,
			type: 'post',
			dataType: 'json',
			data : data,
			error: function(){
							
			},
			success: function(res){
				
				console.log(res);
				
				self.setState({ successfully_submited : true });
			}
		});
	},*/
	
	componentDidMount : function(){
		
		var self = this;
		
		/*parent.postMessage({
			action : 'form_loaded',
		}, '*');*/
			
		if(this.props.values.success){
			parent.postMessage({
				action : 'form_submit',
				status : 'success'
			}, '*');
		}
		
		var selected_category_ids = [];
		
		_.each(self.props.job.categories, (category_name) => {
			
			var category = null;
			
			_.each(self.props.env_info.settings.category_groups, (g) => {
				_.each(g.categories, (c) => {
					if(c.name === category_name){
						category = c;
					}
				})
			})
			
			if(category){
				selected_category_ids.push(category.id);
			}
		})
		
		self.setState({
			selected_category_ids : selected_category_ids
		})
	},
	
	previewPhoto : function(e){
				
		var file = $(e.currentTarget)['context'].files[0];		
		var reader = new FileReader();
		
		reader.onload = function(e){
		    $("td.profile-picture").find('img').attr('src', e.target.result);
		    $("td.profile-picture").find('img').show();
		    $("td.profile-picture").find('.reset-button').addClass('show');
	    }
	
	    reader.readAsDataURL(file);
	},
	
	resetPhoto : function(){
		$("td.profile-picture").find('img').hide();
		$("td.profile-picture").find('.reset-button').removeClass('show');
		$(".profile_picture").val("");
	},
	
	toggleVideoRecorder : function(e){
		
		$('.toggle-video-recorder-button').hide();
		$('<input type="flipbase" />').appendTo($('.video-recorder'));
		
		Flipbase.recorder({
			recorderId: "86aaeafb-7684-40c7-a38c-2e8239eba008",
			callback : function(id){
				$("input[name='flipbase_id']").val(id);
			}
	    });
	},
	
	requestCurrentLocation : function(){
		console.log('request location');	
		
		navigator.geolocation.getCurrentPosition(function(position) {
			$.ajax({
				url: '/geocode',
				type: 'post',
				dataType: 'json',
				data : {
					lat : position.coords.latitude,
					lng : position.coords.longitude,
				},
				error: function(){
								
				},
				success: function(res){
					if(res.status === 'ok'){
						$("td.address").find("input[name='address']").val('');
						$("td.address").find("input[name='address']").val(res.formatted_address);
					}
				}
			});
  		});
	},
	
	onSubmit : function(e){
		
		var apply_form_required_fields = this.props.env_info.settings.apply_form_required_fields;
			apply_form_required_fields = (!_.isUndefined(apply_form_required_fields)) ? apply_form_required_fields.split(',') : [];
		
		var has_missing_required = [];
		
		// name
		if($("input[name='name']").css('display') !== 'none'){
			if($("input[name='name']").val().trim() === '' || $("input[name='name']").val().split(' ').trim().length === 1){
				e.preventDefault();
				$("input[name='name']").css('border', '2px solid #E6A8BD');
				has_missing_required.push('name');
			} else {
				$("input[name='name']").css('border', '1px solid #ddd');
			}
		}
		
		// first_name
		if($("input[name='first_name']").length){
			if($("input[name='first_name']").val() === ''){
				e.preventDefault();
				$("input[name='first_name']").css('border', '2px solid #E6A8BD');
				has_missing_required.push('first_name');
			} else {
				$("input[name='first_name']").css('border', '1px solid #ddd');
			}
		}
		
		// last_name
		if($("input[name='last_name']").length){
			if($("input[name='last_name']").val() === ''){
				e.preventDefault();
				$("input[name='last_name']").css('border', '2px solid #E6A8BD');
				has_missing_required.push('last_name');
			} else {
				$("input[name='last_name']").css('border', '1px solid #ddd');
			}
		}
			
		// birthdate
		if(LanguageStore.get('apply_form/title/personal/birthdate') !== ""){
			if(_.indexOf(apply_form_required_fields, 'birthdate') !== -1){
				if($("input[name='birthdate']").val() === ''){
					e.preventDefault();
					$("input[name='birthdate']").css('border', '2px solid #E6A8BD');
					has_missing_required.push('birthdate');
				} else {
					$("input[name='birthdate']").css('border', '1px solid #ddd');
				}
			}
		}
		
		// address
		if(_.indexOf(apply_form_required_fields, 'address') !== -1){
			if($("input[name='address']").val() === ''){
				e.preventDefault();
				$("input[name='address']").css('border', '2px solid #E6A8BD');
				has_missing_required.push('address');
			} else {
				$("input[name='address']").css('border', '1px solid #ddd');
			}
		}
		
		// email
		if(_.indexOf(apply_form_required_fields, 'email') !== -1){
			if($("input[name='email']").val() === '' || $("input[name='email']").val().indexOf('@') === -1 || $("input[name='email']").val().indexOf('.') === -1){
				e.preventDefault();
				$("input[name='email']").css('border', '2px solid #E6A8BD');
				has_missing_required.push('email');
			} else {
				$("input[name='email']").css('border', '1px solid #ddd');
			}
		}
		
		// phone
		if(_.indexOf(apply_form_required_fields, 'phone') !== -1){
			if($("input[name='phone']").val() === ''){
				e.preventDefault();
				$("input[name='phone']").css('border', '2px solid #E6A8BD');
				has_missing_required.push('phone');
			} else {
				$("input[name='phone']").css('border', '1px solid #ddd');
			}
		}
		
		// file:cv
		if(LanguageStore.get('apply_form/title/files/cv') !== ""){
			if(_.indexOf(apply_form_required_fields, 'file:cv') !== -1){
							
				if($("input[name='cv_file']").val() === ''){
					e.preventDefault();
					$("input[name='cv_file']").css('border', '2px solid #E6A8BD');
					has_missing_required.push('cv');
				} else {
					$("input[name='cv_file']").css('border', 'none');
				}
			}
		}
		
		// gender
		if(_.indexOf(apply_form_required_fields, 'gender') !== -1){
			if($("input[name='gender']").val() === ''){
				e.preventDefault();
				$(".gender-selctor").css('border', '2px solid #E6A8BD');
				$(".gender-selctor").css('padding', '5px');
				$(".gender-selctor").css('display', 'inline-block');
				has_missing_required.push('gender');
			} else {
				$(".gender-selctor").css('border', 'none');
				$(".gender-selctor").css('padding', '0px');
			}
		}
		
		if($("input[name='privacy-agree']").length && !$("input[name='privacy-agree']").is(':checked')){
			
			e.preventDefault();
			
			$(".section.agree-message").css('background', '#E6A8BD');
			
			//$("form").find(".section.agree-message").effect( "highlight", { color:"red" }, 1000 );
		}
		
		if(has_missing_required.length > 0){
			if(!inIframe()){
				alert('Required: ' + (has_missing_required.join(', ')));
			}
		}
	},
	
	// Render
  	render: function(){
  		
  		var self = this;
  		
  		var show = [
  			//'birthdate',
  			//'gender'
  		];
  		
  		var name_placeholder = '';
  		var email_placeholder = '';
  		var phone_placeholder = '';
  		var location_placeholder = '';
  		
  		console.log(this.props);
  		
  		if(self.props.env_info.name === 'careerscout'){
	  		name_placeholder = 'Name';
	  		email_placeholder = 'Email Address';
	  		phone_placeholder = 'Phone';
  		}
  		
  		var job_slug = this.props.values.job_slug;
  		
  		if(!job_slug || job_slug === ''){
	  		job_slug = slugify(this.props.title);
  		}
  		
  		var applyButtonText = LanguageStore.get('apply_form/link/apply');
  		var vacancyUrl = '/'+this.props.values.env+'/'+this.props.values.job_id+'/'+job_slug;
  		
  		if(this.props.values.job_id == 0){
	  		vacancyUrl = '/'+this.props.values.env;	
	  		
	  		if(this.props.env_info.website_url){
		  		var website_url = this.props.env_info.website_url;
		  			website_url = (website_url.indexOf('http') == -1) ? 'https://'+website_url : website_url;
		  		
		  		vacancyUrl = website_url;
	  		}
  		}
  			
  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != ''){
  			var custom_domain = this.props.env_info.custom_job_board_domain;
  			vacancyUrl = 'https://'+custom_domain+'/job/'+this.props.values.job_id+'/'+job_slug;	
  			
  			if(this.props.values.job_id == 0){
	  			vacancyUrl = 'https://'+custom_domain;	
	  			
	  			if(this.props.env_info.website_url){
			  		var website_url = this.props.env_info.website_url;
			  			website_url = (website_url.indexOf('http') == -1) ? 'https://'+website_url : website_url;
			  		
			  		vacancyUrl = website_url;
		  		}
  			}
  		}
  		
  		if(this.props.values.success){
	  		
	  		var complete_message = LanguageStore.get('apply_form/complete/message');
	  		
	  		if(!complete_message || complete_message === ''){
		  		complete_message = 'Successfully submitted';
	  		}
	  		
	  		var back_to_vacancy_link = (<a href={vacancyUrl}>{LanguageStore.get('apply_form/complete/link/back_to_vacancy')}</a>);
	  		
	  		if(self.props.values.env === 'las'){
		  		back_to_vacancy_link = (<a href="https://www.degrootpit.nl/vacatures" target="_blank">{LanguageStore.get('apply_form/complete/link/back_to_vacancy')}</a>);
	  		}
	  		
	  		return (
	  			<div className="apply-form">
			
					<div className="content">
						
						<div className="success">
							<span className="fa fa-check icon"></span>
							<span classname="text">{complete_message}</span>
							<div className="clear"></div>
							
							{back_to_vacancy_link}
						</div>
						
					</div>
					
				</div>
	  		)
	  		
  		} else {
  		
  		var formAction = '//jobs.searchsoftware.nl/'+this.props.values.env+'/apply/'+this.props.values.job_id+'/'+this.props.values.job_slug;
  		
  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != ''){
  			var custom_domain = this.props.env_info.custom_job_board_domain;
	  		formAction = '//'+custom_domain+'/apply/'+this.props.values.job_id+'/'+this.props.values.job_slug;
  		}
  		
  		/*if(self.props.values.env === 'jb'){
	  		formAction = formAction.replace('/apply/', '/apply-formidable/');
	  		console.log('FORMIDABLE', formAction);
  		}*/
  		
  		var errors_array = (typeof this.props.values.errors != 'undefined') ? this.props.values.errors : [];
  		var errors = '';

  		_.each(errors_array, function(err){
	  		errors += '<li>'+err+'</li>'
  		});

  		var errorList = (errors_array.length > 0) ? (<ul className="error-list" dangerouslySetInnerHTML={{__html: errors }}></ul>) : '';
	
		var birthdate_el = (LanguageStore.get('apply_form/title/personal/birthdate') === "") ? '' : (<tr>
		   	<td>{LanguageStore.get('apply_form/title/personal/birthdate')}</td>
		   	<td><input type="text" name="birthdate" defaultValue={this.props.values.birthdate} placeholder="DD-MM-YYYY" /></td>
		</tr>);			  		
   		
   		var gender_el = (LanguageStore.get('apply_form/title/personal/gender') === "") ? '' : (<tr>
			<td>{LanguageStore.get('apply_form/title/personal/gender')}</td>
		   		<td className="gender-content">
		   			<GenderSelector gender={this.props.values.gender} />
		   		</td>
		</tr>);
   		
   		var resetButtonClasses = (this.props.values.profile_picture != '') ? 'reset-button show' : 'reset-button';
   		
   		var videoRecorder = "";
   		var extraFile = "";
   		
   		if(LanguageStore.get('apply_form/title/files/video') != ""){
	   		videoRecorder = (<tr>
			   	<td valign="top">{LanguageStore.get('apply_form/title/files/video')}</td>
			   	<td className="video-input">
			   		<span className="toggle-video-recorder-button" onTouchEnd={this.toggleVideoRecorder} onClick={this.toggleVideoRecorder}>
			   			<i className="fa fa-video-camera icon"></i> <span className="text">{LanguageStore.get('apply_form/link/toggle_video_recorder')}</span>
			   		</span>
			   		<div className="video-recorder"></div>
			   	</td>
			</tr>);
		}
   		
   		if(LanguageStore.get('apply_form/title/files/extra1') != ""){
	   		extraFile = (<tr>
		   		<td>{LanguageStore.get('apply_form/title/files/extra1')}</td>
		   		<td><input onChange={this.previewPhoto} type="file" name="extra_file1" /></td>
		   	</tr>);
   		}
   		
   		var files_style = {};
   		var cv_style = {};
   		var photo_style = {};
   		var message_style = {};
   		
   		if(LanguageStore.get('apply_form/title/files/cv') === ""){
	   		cv_style.display = "none";
   		}
   		
   		if(LanguageStore.get('apply_form/title/files/photo') === ""){
	   		photo_style.display = "none";
   		}
   		
   		if(LanguageStore.get('apply_form/title/files/cv') === "" &&
   		LanguageStore.get('apply_form/title/files/photo') === "" &&
   		LanguageStore.get('apply_form/title/files/extra1') === "" &&
   		LanguageStore.get('apply_form/title/files/video') === ""){
   			files_style.display = "none";
   		}
   		
   		var source_group = "";
   		if(!_.isUndefined(this.props.env_info.source_group) && this.props.env_info.source_group.length > 0){
	   		
	   		source_group = (<div className="section message">
	   			<h3>{LanguageStore.get('apply_form/title/source')}</h3>
			   	<select name="source_id">
			   		<option value={0}>Source</option>
	   				{this.props.env_info.source_group.map(function(source){
		   				return (<option value={source.id}>{source.name}</option>);
		   			})}
	   			</select>
		   	</div>);
   		}
   		
   		// name
   		var name_el = (<tr>
			<td>{LanguageStore.get('apply_form/title/personal/name')}</td>
		  	<td><input type="text" name="name" defaultValue={this.props.values.name} placeholder={name_placeholder} /></td>
			<td className="profile-picture" rowSpan="4">
		   		<img src={this.props.values.profile_picture} />
		   		<div className="clear"></div>
		   		<span onClick={this.resetPhoto} className={resetButtonClasses}><i className="fa fa-close"></i></span>
			</td>
		</tr>);
		
		if(self.props.values.env === 'jb' || self.props.values.env === 'htnk'){
			// first_name + last_name
	   		name_el = (<tr>
				<td>{LanguageStore.get('apply_form/title/personal/name')}</td>
			  	<td>
			  		<input type="text" name="name" defaultValue={this.props.values.name} style={{display:'none'}} />
			  		<input 
			  			style={{width:'44%',marginRight:'10px'}}
			  			type="text" 
			  			name="first_name" 
			  			defaultValue={this.props.values.first_name} 
			  			placeholder="First Name" 
			  			onBlur={() => {
			  				
			  				var name = $("input[name='first_name']").val() + ' ' + $("input[name='last_name']").val();
			  				
				  			$("input[name='name']").val(name)
			  			}}
			  		/>
			  		<input 
			  			style={{width:'44%'}}
			  			type="text" 
			  			name="last_name" 
			  			defaultValue={this.props.values.last_name} 
			  			placeholder="Last Name" 
			  			onBlur={() => {
			  				
			  				var name = $("input[name='first_name']").val() + ' ' + $("input[name='last_name']").val();
			  				
				  			$("input[name='name']").val(name)
			  			}}
			  		/>
			  	</td>
				<td className="profile-picture" rowSpan="4">
			   		<img src={this.props.values.profile_picture} />
			   		<div className="clear"></div>
			   		<span onClick={this.resetPhoto} className={resetButtonClasses}><i className="fa fa-close"></i></span>
				</td>
			</tr>);
		}
		
		// address
		var request_location_button = null //(<span onClick={this.requestCurrentLocation} className="fa fa-map-marker request-location-button"></span>);
		
		var address_el = '';
		
		if(LanguageStore.get('apply_form/title/personal/address') !== ''){
			address_el = (<tr>
				<td className="address-label">{LanguageStore.get('apply_form/title/personal/address')} {request_location_button}</td>
				<td className="address"><input type="text" name="address" defaultValue={this.props.values.address} placeholder={location_placeholder} /></td>
			</tr>);
		}
		
		if(self.props.env_info.name === 'zilverwerkt' || self.props.env_info.name === 'jb'){
			address_el = (<tr>
				<td className="address-label">{LanguageStore.get('apply_form/title/personal/address')} {request_location_button}</td>
				<td className="address">
					<input type="text" name="address" defaultValue={this.props.values.address} placeholder="Adres" style={{width:'44%',marginRight:'10px'}} />
					<input type="text" name="city" defaultValue={this.props.values.city} placeholder="Woonplaats" style={{width:'44%'}} />
				</td>
			</tr>);
		}
		
		if(self.props.env_info.name === 'careerscout'){
			address_el = null;
		}
		
		// email
		var email_el = (<tr>
			<td>{LanguageStore.get('apply_form/title/contact_details/email')}</td>
			<td><input type="text" name="email" defaultValue={this.props.values.email} placeholder={email_placeholder} /></td>
		</tr>);
		
		// phone
		var phone_el = (<tr>
			<td>{LanguageStore.get('apply_form/title/contact_details/phone')}</td>
			<td><input type="text" name="phone" defaultValue={this.props.values.phone} placeholder={phone_placeholder} /></td>
		</tr>);
		
   		var agree_message_el = "";
   		var agree_message_text = "";
   		
   		if(!_.isUndefined(this.props.env_info.settings.job_board_apply_form_agree_message)){
   			if(this.props.env_info.settings.job_board_apply_form_agree_message !== ''){
	   			agree_message_text = this.props.env_info.settings.job_board_apply_form_agree_message;
	   		}	
   		}
   		
   		if(agree_message_text !== ''){
	   		agree_message_el = (<div className="section agree-message">
	   			<h3>{LanguageStore.get('apply_form/title/terms')}</h3>
	 			<input type="checkbox" name="privacy-agree" /> <Linkify tagName="span">{agree_message_text}</Linkify>
			</div>);
   		}
   		
   		var linkedin_button_el = "";
   		
   		if(LanguageStore.get('job_ad/link/connect_with_linkedin') !== ''){
   			
   			var linkedinURL = 'http://jobs.searchsoftware.nl/linkedin?env='+this.props.values.env+'&job_id='+(this.props.values.job_id || 0);
   			
   			if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != ''){
	  			var custom_domain = this.props.env_info.custom_job_board_domain;
		  		linkedinURL += '&d='+custom_domain;
	  		}
	  		
   			linkedin_button_el = (<a className="connect-linkedin-button" href={linkedinURL}>
   				<i className="icon fa fa-linkedin-square"></i> {LanguageStore.get('job_ad/link/connect_with_linkedin')}
   			</a>);
   		}
   		
   		if(!_.isUndefined(this.props.env_info.settings.is_callback) && (this.props.env_info.settings.is_callback === true || this.props.env_info.settings.is_callback === 'true')){
   			console.log('IS CALLBACK');
   			formAction += '?w=callback';
   			email_el = "";
   			address_el = "";
   			files_style.display = 'none';
   			message_style.display = 'none';
   			source_group = "";
   			birthdate_el = "";
   			gender_el = "";
   			linkedin_button_el = "";
   			//applyButtonText = "Submit";
   		}
   		
   		var cancel_el = '';
   		
   		if(LanguageStore.get('apply_form/link/cancel') !== ''){
	   		cancel_el = (<a className="cancel" href={vacancyUrl}>{LanguageStore.get('apply_form/link/cancel')}</a>);
   		}
   		
   		//console.log('HERE', self.props);
   		
   		var applyFormClasses = "apply-form";
   		var form_title_el = null;
   		
   		if(self.props.env_info.name === 'searchs'){
	   		applyFormClasses += " searchs_custom";
	   		form_title_el = (<div className="custom-title">
	   			<img style={{ transform: 'scale(1.4)' }} src="https://app.searchsoftware.nl/logo/searchs" /> <a href="https://searchsoftware.nl" target="_blank" className="apply-form-custom-title">Searchsoftware</a>
	   		</div>);	
   		}
   		
   		if(self.props.env_info.name === 'careerscout'){
	   		//applyFormClasses += " searchs_custom";
	   		form_title_el = (<div className="custom-title" style={{marginTop:'30px'}}>
	   			<img src="https://images.searchsoftware.nl/logo/careerscout" style={{height:'120px',marginLeft:'20px'}} />
	   		</div>);	
   		}
   		
   		var job_alert_subscribe_el = null;
   		
   		if(self.props.env_info.name === 'jb' || self.props.env_info.name === 'sres' || self.props.env_info.name === 'ocre' || self.props.env_info.name === 'ocremed' || self.props.env_info.name === 'demo' || self.props.env_info.name === 'spotlights'){
	   		
	   		var selected_categories = null;
	   		var show_more_categories = null;
	   		
	   		if(self.state.job_alert_subscribe && self.props.env_info.settings.category_groups && self.props.env_info.settings.category_groups.length){
		   		
		   		if(self.state.show_more_categories){
			   		show_more_categories = (<div className="show-more-subscribe-categories" onClick={() => {
				   		self.setState({ show_more_categories : false });
			   		}}>- Show less categories</div>)
		   		} else {
			   		show_more_categories = (<div className="show-more-subscribe-categories" onClick={() => {
				   		self.setState({ show_more_categories : true });
			   		}}>+ Show more categories</div>)
		   		}
		   		
		   		selected_categories = (<div>
		   		
		   			<input type="hidden" name="categories" value={self.state.selected_category_ids.join(',')} />
		   			
		   			{self.props.env_info.settings.category_groups.map((g) => {
			   			
			   			var group_title_el = null;
			   			
			   			if(self.state.show_more_categories || g.categories.filter(c => _.indexOf(self.state.selected_category_ids, c.id) !== -1)[0]){
				   			group_title_el = (<div style={{marginTop:'10px',fontWeight:'bold'}} className="subscribe-categories-title">{g.name}</div>);
			   			}
			   			
						return (<div key={g.id}>
							
							{group_title_el}
							
							{g.categories.map((c) => {
								
								if(_.indexOf(self.state.selected_category_ids, c.id) === -1){
									
									if(self.state.show_more_categories){
										return (<div key={c.id}>
											<input type="checkbox" checked={false} onClick={() => {
												self.setState({
													selected_category_ids : self.state.selected_category_ids.concat(c.id)
												})
											}} /> {c.name}
										</div>)
									} else {
										return null;
									}
								}
								
								return (<div key={c.id}>
									<input type="checkbox" checked={true} onClick={() => {
										self.setState({
											selected_category_ids : _.reject(self.state.selected_category_ids, category_id => category_id === c.id)
										});
									}} /> {c.name}
								</div>)
							})}
						</div>);	
					})}
		   		</div>)
	   		}
	   		
	   		job_alert_subscribe_el = (<div className="section agree-message">
	   			<h3>Job Notifications</h3>
	 			<input type="checkbox" name="subscribe-to-job-alerts" checked={self.state.job_alert_subscribe} onClick={() => {
		 			self.setState({ 
			 			job_alert_subscribe : !self.state.job_alert_subscribe,
			 			show_more_categories : (self.state.selected_category_ids.length === 0) ? true : self.state.show_more_categories
			 		});
	 			}}/> Subscribe to Job Notifications
	 			
	 			{selected_categories}
	 			
	 			{show_more_categories}
	 			
			</div>);
   		}
   		
   		if(true){
	   		linkedin_button_el = null;
   		}
   		
   		return (
   			<div className={applyFormClasses}>
				
				{form_title_el}
				
				<div className="content">
	   				
	   				{errorList}
	   				
	   				<form action={formAction} method="post" encType="multipart/form-data" onSubmit={self.onSubmit}>
	   					
	   					<input type="hidden" name="profile_picture" value={this.props.values.profile_picture} />
	   					<input type="hidden" name="flipbase_id" />
	   						
		   				<div className="section personal">
		   					<h3>{LanguageStore.get('apply_form/title/personal')}{linkedin_button_el}</h3>
		   					<table cellSpacing="0px" cellPadding="0px">
		   						<tbody>
			   						{name_el}
			   						{birthdate_el}
			   						{gender_el}
			   						{address_el}
		   						</tbody>
		   					</table>
		   				</div>
		   				
		   				<div className="section contact">
		   					<h3>{LanguageStore.get('apply_form/title/contact_details')}</h3>
			   				<table cellSpacing="0px" cellPadding="0px">
			   					<tbody>
			   						{email_el}
			   						{phone_el}
		   						</tbody>
		   					</table>
		   				</div>
		   				
		   				<div className="section social" style={files_style}>
		   					<h3>{LanguageStore.get('apply_form/title/files')}</h3>
			   				<table cellSpacing="0px" cellPadding="0px">
			   					<tbody>
			   						<tr style={cv_style}>
			   							<td>{LanguageStore.get('apply_form/title/files/cv')}</td>
			   							<td><input type="file" name="cv_file" /></td>
			   						</tr>
			   						<tr style={photo_style}>
			   							<td>{LanguageStore.get('apply_form/title/files/photo')}</td>
			   							<td><input onChange={this.previewPhoto} type="file" name="photo_file" /></td>
			   						</tr>
			   						{extraFile}
			   						{videoRecorder}
		   						</tbody>
		   					</table>
		   				</div>
		   				
		   				<div className="section message" style={message_style}>
		   					<h3>{LanguageStore.get('apply_form/title/message')}</h3>
			   				<textarea name="message" defaultValue={this.props.values.message} />
		   				</div>
		   				
		   				{source_group}
		   				
		   				{job_alert_subscribe_el}
		   				
		   				{agree_message_el}
		   				
		   				<div className="section apply">
			   				<table className="buttons" cellSpacing="0px" cellPadding="0px">
			   					<tbody>
			   						<tr>
			   							<td><input type="submit" className="apply" value={applyButtonText} /></td>
			   							<td>{cancel_el}</td>
			   						</tr>
		   						</tbody>
		   					</table>
		   				
		   				</div>
	   				</form>
   				</div>

	  		</div>
	  	);
	  	}
	}
});



function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}